/**
 * Geographic filters for GET /eventstypes and GET /artists (optional).
 * Backend should accept the same query parameters as GET /events for place scope:
 * - `region`: comma-separated region IDs (omit when no region filter).
 * - `cities_id`: comma-separated city IDs (omit when no city filter).
 * When both are omitted, the API returns the full catalog (backward compatible).
 *
 * @param {false|Array<{ value: string, label?: string }>} searchRegion
 * @param {false|Array<{ value: string, label?: string }>} searchVille
 * @returns {Record<string, string>}
 */
export function buildGeoParamsForLookups(searchRegion, searchVille) {
    const params = {};
    const regionIds =
        Array.isArray(searchRegion) && searchRegion.length > 0
            ? searchRegion.filter((r) => r && r.value && r.value !== 'all').map((r) => r.value)
            : [];
    const cityIds =
        Array.isArray(searchVille) && searchVille.length > 0
            ? searchVille.filter((v) => v && v.value && v.value !== 'all').map((v) => v.value)
            : [];
    if (regionIds.length > 0) {
        params.region = regionIds.join(',');
    }
    if (cityIds.length > 0) {
        params.cities_id = cityIds.join(',');
    }
    return params;
}
